export const crews = {
    actions: {
        getCrew(context, crewId) {
            return context.dispatch('get', {
                url: api + 'crews/' + crewId,
                params: {
                    include:
                        'crew_users.user:fields(id|first_name|last_name|full_name|picture),' +
                        'crew_users.user.crew_user_groups'
                }
            });
        },

        deleteCrew(context, crew) {
            return context.dispatch('post', {
                url: api + 'delete-crew',
                data: {
                    crew_id: crew.id
                }
            });
        }
    }
};

export default crews;
